module.exports = __webpack_public_path__ + "img/phoneImg4.d182fcfa.jpg";